var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"anticon anticon-container",attrs:{"aria-label":"图标: container"}},[_c('tk-icon',{staticStyle:{"margin-top":"-6px"},attrs:{"size":16}},[_vm._v("usermamage")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }